import type { paths } from "../../__definitions__/teams-engine-v2.changeengine.com-definitions";
import type { Workers } from "../../utils/service-url";
import type { ApiResponse } from "./client";
import { WorkerApiService } from "./worker";

export type TeamsEngineV2BuildMessageRequest =
  paths["/build-message"]["post"]["requestBody"]["content"]["application/json"];

export type TeamsEngineV2Message =
  paths["/build-message"]["post"]["responses"]["200"]["content"]["application/json"];

export class TeamsEngineSevice extends WorkerApiService {
  module = "teams-engine-v2" as const satisfies Workers;

  async buildMessage(
    body: TeamsEngineV2BuildMessageRequest,
  ): Promise<ApiResponse<TeamsEngineV2Message>> {
    return await this.post("build-message", { ...body });
  }
}
